module.exports = __webpack_public_path__ + "media/images/ac_templates/201/rstht-f970ae18558d12e0d18f6e235aa676c9.jpg";